import { Skeleton } from '@/components/feedback/Skeleton'
import { RequireAuth } from '@/routes/RequireAuth'
import { RequireOnboarding } from '@/routes/RequireOnboarding'
import { Root } from '@/routes/Root'
import { type ReactNode, Suspense, lazy } from 'react'
import { createBrowserRouter } from 'react-router'

const Deck = lazy(() => import('@/views/Deck').then((m) => ({ default: m.Deck })))
const Garden = lazy(() => import('@/views/Garden').then((m) => ({ default: m.Garden })))
const Login = lazy(() => import('@/views/Login').then((m) => ({ default: m.Login })))
const Onboard = lazy(() => import('@/views/Onboard').then((m) => ({ default: m.Onboard })))
const PlatformRouter = lazy(() =>
  import('@/routes/PlatformRouter').then((m) => ({ default: m.PlatformRouter })),
)
const Profile = lazy(() => import('@/views/Profile').then((m) => ({ default: m.Profile })))

const SuspenseView = ({ children }: { children: ReactNode }) => (
  <Suspense
    fallback={
      <div className="wefa-route-status">
        <Skeleton variant="text" />
      </div>
    }
  >
    {children}
  </Suspense>
)

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <SuspenseView>
        <PlatformRouter />
      </SuspenseView>
    ),
  },
  {
    path: '/login',
    element: (
      <SuspenseView>
        <Login />
      </SuspenseView>
    ),
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/onboard',
        element: (
          <SuspenseView>
            <Onboard />
          </SuspenseView>
        ),
      },
      {
        element: <RequireOnboarding />,
        children: [
          {
            element: <Root />,
            children: [
              {
                path: '/deck',
                element: (
                  <SuspenseView>
                    <Deck />
                  </SuspenseView>
                ),
              },
              {
                path: '/garden',
                element: (
                  <SuspenseView>
                    <Garden />
                  </SuspenseView>
                ),
              },
              {
                path: '/profile',
                element: (
                  <SuspenseView>
                    <Profile />
                  </SuspenseView>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
])
